import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import PrivacyPolicy from './components/PrivacyPolicy';
import RefundPolicy from './components/RefundPolicy';
import TermsConditions from './components/TermsConditions';
import AccountDeletion from './components/AccountDeletion';
import RewardsPolicy from './components/RewardsPolicy';
import FAQ from './components/FAQ';

import ReelChallenge from './components/ReelChallenge';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/account-deletion" element={<AccountDeletion />} />
          <Route path="/rewards-policy" element={<RewardsPolicy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/reel-challenge" element={<ReelChallenge />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;